import { GarageUtilitiesContainer } from '../../containers/advancedFilters/GarageUtilitiesContainer';
import { IFilter } from '../../types/advancedFilters';

export const garageUtilities: IFilter = {
  component: GarageUtilitiesContainer,
};
